<template>
  <div class="container px-8 pt-8 mx-auto lg:px-16">
    <h2
      id="parlentDeNous"
      class="text-4xl font-bold tracking-wider uppercase font-raleway"
    >
      Ils parlent de nous
    </h2>
    <hr class="mb-10 antialiased border border-green-500" />
    <carousel v-bind="carouselSettings" class="mb-20 overflow-visible">
      <slide class="w-full" v-for="article in articles" :key="article">
        <div
          class="mx-3 transition-all duration-150 transform shadow-none hover:shadow-xl hover:scale-105 article-card"
        >
          <a
            :href="article.url"
            target="_blank"
            rel="noopener noreferrer"
            class="block w-full h-full overflow-hidden text-center bg-gray-500 rounded-lg "
          >
            <div class="w-full h-auto overflow-hidden">
              <img
                :src="'img/articles/' + article.thumbnail + 'Thumbnail.png'"
                :alt="article.name"
                class="w-full"
              />
            </div>
            <div class="px-4 pt-2 pb-6 ">
              <img
                :src="'img/articles/' + article.logo + 'Logo.png'"
                :alt="article.name"
                class="h-8 mx-auto my-2"
              />
              <hr class="w-6 mx-auto mt-4 border-t-2 border-green-300" />
              <p class="h-16 mt-3 mb-4 italic leading-snug">
                “{{ article.quote }}”
              </p>
              <span class="font-bold text-green-500 ">
                <span>Lire l'article</span> >
              </span>
            </div>
          </a>
        </div>
      </slide>
    </carousel>

    <h2
      id="nousFontConfiance"
      class="text-4xl font-bold tracking-wider uppercase font-raleway"
    >
      Ils nous font confiance
    </h2>
    <hr class="mb-10 antialiased border border-green-500" />
    <div id="logos" class="flex flex-row flex-wrap w-full mb-20">
      <a
        class="flex items-center flex-grow mx-1 mb-4 transition-all duration-200 transform opacity-100 hover:opacity-75 md:mx-3 lg:mx-6 justify-items-center hover:scale-110"
        v-for="logo in logos"
        :key="logo"
        :href="logo.url"
        target="_blank"
        rel="noopener noreferrer"
      >
        <v-lazy-image
          :src="'img/logos/' + logo.image + '@1x.png'"
          :alt="logo.name"
          class="block mx-auto md:hidden"
          :style="'width: ' + logo.width * 0.66 + 'px'"
        />
        <v-lazy-image
          :src="'img/logos/' + logo.image + '@2x.png'"
          :alt="logo.name"
          class="hidden mx-auto md:block"
          :style="'width: ' + logo.width + 'px'"
        />
      </a>
    </div>
  </div>
</template>

<script>
import VLazyImage from "v-lazy-image";

import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    VLazyImage,
    Carousel,
    Slide,
  },
  data() {
    return {
      carouselSettings: {
        perPage: 1,
        perPageCustom: [[640, 2], [1024, 3], [1240, 4]],
        paginationPadding: 0,
        paginationActiveColor: "#35C5A5",
        paginationColor: "#808080",
      },
      articles: [
        {
          name: "Blackfoot",
          quote:
            "Retour sur notre dernière étude : ses objectifs, le déroulé et les résultats !",
          logo: "blackfoot",
          thumbnail: "blackfeed",
          url: "https://feed.blackfoot.io/blog/etude-alpha-herdingcats",
        },
        {
          name: "Epitech",
          quote:
            "HerdingCats : le collier made in Epitech qui vous livre la vie secrète de votre chat !",
          logo: "epitech",
          thumbnail: "epitech",
          url:
            "https://www.epitech.eu/fr/actualites-evenements/herdingcats-le-collier-made-in-epitech-qui-vous-livre-la-vie-secrete-de-votre-chat/",
        },
        {
          name: "Promistel",
          quote:
            "HerdingCats nous a contacté avec un besoin bien spécifique : suivre l'activité des chats.",
          logo: "promistel",
          thumbnail: "promistel",
          url:
            "https://promistel.com/fr/news/septembre-2019/la-vie-secr%C3%A8te-des-chats.html",
        },
        {
          name: "Soon Soon Soon",
          quote: "Connecter son chat pour surveiller sa santé",
          logo: "soonsoonsoon",
          thumbnail: "soonsoonsoon",
          url:
            "https://www.soonsoonsoon.com/fr/detections/connecter-son-chat-pour-surveiller-sa-sante/",
        },
        {
          name: "Blackfoot",
          quote: "HerdingCats ou que fait mon chat quand je ne suis pas là ?",
          logo: "blackfoot",
          thumbnail: "blackfoot",
          url: "https://blackfoot.io/projects/HerdingCats/",
        },
      ],
      logos: [
        {
          name: "Blackfoot",
          image: "Blackfoot",
          url: "https://blackfoot.io/",
          width: 188,
        },
        {
          name: "La Vie Secrète des Chats",
          image: "LVSDC",
          url: "https://www.tf1.fr/tf1/la-vie-secrete-des-chats",
          width: 115,
        },
        // {
        //   name: "Epitech",
        //   image: "Epitech",
        //   url: "https://www.epitech.eu/",
        //   width: 147,
        // },
        {
          name: "Refuge AVA",
          image: "AVA",
          url: "https://avarefuge.fr/",
          width: 72,
        },
        {
          name: "The Machinery",
          image: "TheMachinery",
          url: "https://www.themachinery.fr/",
          width: 229,
        },
        // {
        //   name: "Animal University",
        //   image: "AnimalUniversity",
        //   url: "https://www.animal-university.fr/",
        //   width: 78,
        // },
        {
          name: "Clinique vétérinaire du Pont de Neuilly",
          image: "CliniquePontDeNeuilly",
          url: "https://www.cliniqueveterinairepontdeneuilly.fr/",
          width: 72,
        },
        // {
        //   name: "KissKissBankBank",
        //   image: "KKBB",
        //   url: "https://www.kisskissbankbank.com/",
        //   width: 183,
        // },
        {
          name: "TF1",
          image: "TF1",
          url: "https://www.tf1.fr/",
          width: 113,
        },
        // {
        //   name: "Boehringer Ingelheim",
        //   image: "BoehringerIngelheim",
        //   url: "https://www.boehringer-ingelheim.com/",
        //   width: 172,
        // },
        // {
        //   name: "Bouygues",
        //   image: "Bouygues",
        //   url: "https://www.bouygues.com/en/",
        //   width: 154,
        // },
        {
          name: "BBC Studios",
          image: "BBCStudios",
          url: "https://www.bbcstudios.com/",
          width: 148,
        },
        // {
        //   name: "Laboratoire de Psychologie Cognitive",
        //   image: "LaboratoirePsychologieCognitive",
        //   url: "https://lpc.univ-amu.fr/fr",
        //   width: 124,
        // },
        {
          name: "Ionis",
          image: "Ionis",
          url: "https://www.ionis-group.com/",
          width: 107,
        },
        // {
        //   name: "Aix-Marseille Universite",
        //   image: "AixMarseilleUniversite",
        //   url: "https://www.univ-amu.fr/en",
        //   width: 145,
        // },
        // {
        //   name: "e-artsup",
        //   image: "e-artsup",
        //   url: "https://www.e-artsup.net/",
        //   width: 150,
        // },
        // {
        //   name: "Epitech Innovation Hub",
        //   image: "EpitechInnovationHub",
        //   url: "https://www.epitech.eu/en/innovation-hub/",
        //   width: 147,
        // },
        {
          name: "Parole Et Langage",
          image: "ParoleEtLangage",
          url: "http://www.lpl-aix.fr/en/welcome-to-lpl/",
          width: 46,
        },
        // {
        //   name: "Sfeca",
        //   image: "Sfeca",
        //   url: "http://fr.sfeca.info/",
        //   width: 142,
        // },
        {
          name: "CNRS",
          image: "CNRS",
          url: "http://www.cnrs.fr/",
          width: 75,
        },
        {
          name: "Frontline",
          image: "Frontline",
          url: "https://frontline.fr/",
          width: 257,
        },
        // {
        //   name: "Lecd",
        //   image: "Lecd",
        //   url: "https://lecd.parisnanterre.fr/",
        //   width: 134,
        // },
        {
          name: "Université Paris Nanterre",
          image: "UniversitéParisNanterre",
          url: "https://www.parisnanterre.fr/",
          width: 177,
        },
      ],
    };
  },
};
</script>

<style>
.v-lazy-image {
  @apply opacity-0 transition-opacity duration-300;
}

.v-lazy-image-loaded {
  @apply opacity-100;
}

.VueCarousel-wrapper {
  overflow: hidden;
}

.VueCarousel-inner {
  @apply pt-2 pb-12;
}

.VueCarousel-dot {
  @apply mr-6;
}

.VueCarousel-dot:last-child {
  @apply mr-0;
}

.article-card:hover > a > div > span {
  @apply text-green-300;
}

.article-card:hover > a > div > span > span {
  @apply underline;
  text-underline-position: under;
}
</style>
